import { CreateImage } from "../../../Models/index";

export class CreateImageCategory {
  title: string;
  images: Array<CreateImage>;
}
